// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector } from 'reselect';
import { RootState } from '../../rootReducer';
import { NotificationsState } from '../../reducers/notificationsReducer';

export const notificationsRaw = (state: RootState) =>
  state.notificationsReducer;

export const makeNotificationsList = () => {
  return createSelector(
    notificationsRaw,
    (notifications) => notifications.list || [],
  );
};

export const makeNotificationsByKey = (key: keyof NotificationsState) => {
  return createSelector(
    notificationsRaw,
    (notifications) => notifications[key],
  );
};

export const makeNotificationsUnread = () => {
  return createSelector(
    notificationsRaw,
    notifications => (notifications.list || []).filter(notification => !notification.read).length,
  );
};
export const makeIsResetingNotifications = () => {
  return createSelector(
    notificationsRaw,
    notifications => notifications.isReseting,
  );
};
